/**
 * Created by contrapro on 03/04/2018
 */

import {
    ACTION_TYPE_LOGIN_RESULT
} from '../actions';

// import { plantTypeConfig } from '../util/constConfig';
// import {vioPush} from "../util/crmWrapper";

const initialState = {
    gotNewSeed: -1, //外来的种子
    friendUserObjectId: '', //介绍人的lean object id
    openid: '',
    unionid: ''
};

export default function crmAnalyticsReducer(state = initialState, action) {
    switch (action.type) {
        // case ACTION_TYPE_LOGIN:
        //     return Object.assign({}, ...state, {
        //         isAuthenticated: true
        //     });
        case ACTION_TYPE_LOGIN_RESULT:
            //console.log('ACTION_TYPE_LOGIN_RESULT in crmEvent',action.payload);
            const p = action.payload.extraParam ? action.payload.extraParam : {};
            if (p.openid && p.openid !== null && p.openid.length > 0) {
                window._vio.push(['_setUserID', p.openid]);
                window._vio.push(['_trackPageview']); //_setUserID 要在 _trackPageview 之前设置


                //DGS 系统
                window.mixpanel.register({
                    'uid': p.openid, //（必填）此处的uid为当前用户的唯一id,如果是微信则为微信授权后的openid,如果是微博则是微博授权后的uid等等，如无法拿到平台授权的uid，可用cookie代替
                    'srcuid': '',//（选填）此处的srcuid为带来当前uid用户的uid,这个变量微信中多用即来源openid
                    'platform': 'wechat',//（必填）不同渠道，媒体定义在这个变量中 如wechat、weibo、youku……
                    'urlid': 'index'//（必填）此变量为当前页面的标识，如 系统首页：index ，注册页：register 等等。
                });

            }

            // if (p.gotNewSeed >= 0 && p.gotNewSeed <= 4) {
            //     //领种子
            //     //console.log('领了种子', p.gotNewSeed);
            //     const name = plantTypeConfig[p.gotNewSeed].name;
            //     window._vio.push(["_eventParam", "seed_name", name]);
            //     window._vio.push(["_trackEvent", "get_seed"]);
            //
            //     window.mixpanel.track("get_seed", {
            //         "seed_name": name
            //     });
            // }

            return {
                ...state,
                gotNewSeed: p.gotNewSeed,
                friendUserObjectId: p.friendUserObjectId,
                openid: p.openid,
                unionid: p.unionid
            };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/crmAnalyticsReducer.js